/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-02-23 18:04:21 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2018-03-06 14:42:15
 */

import * as React from "react";

import PackingListSelector from "./PackingListSelector";


export default class PackingListPage extends React.Component {

    render() {
        return (
            <div className="packing-list-page">
                <PackingListSelector mailId="5a995b5cebeb7d5dd652f133" />;
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/PackingList/Page.jsx